import React, { useState } from "react";
import { AdvancingTemplateState } from "./model";
import { EditSectionTemplate } from "components/MainSectionTemplate/EditSectionTemplate";
import { routes } from "utilities/routing/generatedRoutes";
import RequiredTextInput from "components/ValidatedFields/RequiredTextInput";
import { TemplateEditForm, getDefaultFormItems } from "./components/TemplateEditForm";

interface AdvancingTemplateNewSectionProps {
  allFormSections: server.dto.AdvancingFormSection[]
}

export const AdvancingTemplateNewSection = (props: AdvancingTemplateNewSectionProps) => {
  const [advancingTemplate, setAdvancingTemplate] = useState<AdvancingTemplateState>({
    name: "",
    templateItems: getDefaultFormItems(props.allFormSections)
  })

  const submit = () => {
    return window.CoreApi.AdvancingFormTemplate.CreateTemplate({
      name: advancingTemplate.name,
      formItems: advancingTemplate.templateItems
    })
  }

  return <EditSectionTemplate
    submit={submit}
    redirectUrl={() => routes.advancingFormTemplate_List().absolute}
    sections={[{
      key: "advancingTemplate",
      type: "regular",
      title: RESX.Advancing.AdvancingTemplate,
      fields: [{
        key: "name",
        hideLabel: true,
        label: RESX.GeneralLabels.Name,
        renderEditNew: () => <div style={{
          paddingLeft: 8,
        }}><RequiredTextInput
            validatorKey="title"
            focusOnMount
            maxLength={serverReference.constants.advancingTemplate.maxNameLength}
            value={advancingTemplate.name}
            onChange={(name) => { setAdvancingTemplate({ ...advancingTemplate, name }); }}
          />
        </div>
      }, {
        key: "formSections",
        hideLabel: true,
        label: "",
        renderEditNew: () => <div style={{
          paddingLeft: 8,
        }}>
          <TemplateEditForm
            allFormSections={props.allFormSections}
            templateItems={advancingTemplate.templateItems}
            onChange={templateItems => setAdvancingTemplate({ ...advancingTemplate, templateItems })}
          />
        </div>
      }]
    }]}
  />
}